import {  Layout, Row, Col} from 'antd';
import React, { Component} from "react";
import {NavLink} from "react-router-dom";


/** *
* *Footer used in all pages. It receives as param if it used in regular user view or admin/jury mode, for a propper link use
@param admin
@param jury
*/
class Foot extends Component {
  render() {
    const { Footer } = Layout;
    return (
        <Footer style={{backgroundColor:'#00b2e7', position:'relative',bottom:'0px',left:'0px',right:'0px',flexShrink:0}}>
          <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#00b2e7',  marginBottom:'0px', bottom:'0px'}}>
            <Col xl={6} xs={24} sm={{span:6}}> <div style={{textAlign: 'center'}}>  <NavLink to={this.props.admin ? "/casa/admin_bases":this.props.jury ? "/casa/jury_bases": "/casa/bases"} style={{color:'white'}}>Bases del concurso</NavLink> </div> </Col>
            <Col xl={4}xs={24} sm={{span:6}}> <div style={{textAlign: 'center'}}> <a style={{color:'white'}} href = "mailto: premiocasa@casa.cult.cu">premiocasa@casa.cult.cu</a></div></Col>
            <Col xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} > <div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
            <Col xl={4}xs={24}sm={{span:6}} > <div style={{textAlign: 'center'}}> <a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
            <Col xl={4} xs={24} sm={{span:24}}> <div style={{textAlign: 'center'}}> <NavLink to={this.props.admin ? "/casa/admin_terminos":this.props.jury ? "/casa/jury_terminos":"/casa/terminos"} style={{color:'white'}}>Términos y condiciones de uso</NavLink> </div> </Col>
          </Row>
        </Footer>
    );
  }
}
export default Foot;


